import React, { Component } from 'react';
import './App.css';
import LayoutContainer from './containers/Layout'

class App extends Component {
  render() {
    return (
      <LayoutContainer />
    );
  }
}

export default App;
